/* eslint-disable */
import { loadStyles } from '@microsoft/load-themed-styles';
loadStyles([{"rawString":".root_4e229857{overflow:auto}"}]);
export const root = "root_4e229857";